import { direct } from "../api/connection";

export interface Action {
  label?: string;
  nav?: string;
  iconClass?: string;
  description?: string;
  disabled?: boolean;
  execute?: () => void;
}

export function handleAction(action: Action) {
  if (action.nav) {
    direct(action.nav);
  } else if (action.execute) {
    action.execute();
  }
}
